import HttpService from "./HttpService";
const API_URL = "/role-permission";

const RolePermissionService = {
  fetchModulePermissions: async () => {
    try {
      const response = await HttpService.get('/permission-get');
      return response.data;
    } catch (error) {
      console.error("Error fetching permissions:", error);
      throw error;
    }
  },

  fetch: async (pageConfig) => {
    const pageConfigParams =  new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(`${API_URL}?${pageConfigParams}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching role and permissions:", error);
      throw error;
    }
  },

  fetchModules: async () => {
    try {
      const response = await HttpService.get('/model-name-permission');
      return response.data;
    } catch (error) {
      console.error("Error fetching modules:", error);
      throw error;
    }
  },
  fetchPermissions: async () => {
    try {
      const response = await HttpService.get('/model-permission');
      return response.data;
    } catch (error) {
      console.error("Error fetching modules:", error);
      throw error;
    }
  },

  giveModuleAccess: async (data) => {
    try {
      const response = await HttpService.post('/model-permission', data);
      return response.data;
    } catch (error) {
      console.error("Error giving module access:", error);
      throw error;
    }
  },

  add: async (data) => {
    try {
      const response = await HttpService.post(API_URL, data);
      return response.data;
    } catch (error) {
      console.error("Error adding role and permissions:", error);
      throw error;
    }
  },

  edit: async (id) => {
    try {
      const response = await HttpService.get(`${API_URL}/${id}/edit`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, updatedData) => {
    // data["_method"] = "PUT";
    try {
      const response = await HttpService.put(`${API_URL}/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating role and permissions:", error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await HttpService.delete(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting role and permissions:", error);
      throw error;
    }
  },

  fetchAssignedRoleUsers: async () => {
    try {
      const response = await HttpService.get('/user-role');
      return response.data;
    } catch (error) {
      console.error("Error fetching role and permissions:", error);
      throw error;
    }
  },
  fetchAssignedRoleUsersPaginated: async (pageConfig) => {
    const pageConfigParams =  new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(`/user-role-paginated?${pageConfigParams}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching role and permissions:", error);
      throw error;
    }
  },

  assignRole: async (data) => {
    try {
      const response = await HttpService.post('/user-role-assign', data);
      return response.data;
    } catch (error) {
      console.error("Error adding role and permissions:", error);
      throw error;
    }
  },

  fetchModelWisePermissions: async (data) => {
    try {
      const response = await HttpService.post('permission-check', data);
      return response.data;
    } catch (error) {
      console.error("Error fetching permissions:", error);
      throw error;
    }
  },
};

export default RolePermissionService;
